<div class="dackl-basic">
  <mytax-pdf-viewer
    id="mytax-pdf-viewer"
    tabindex="0"
    [documentSrc]="(pdfBlob$ | async)"
    [isDownloadButtonInHeaderDisplayed]="true"
    [showSidebar]="false"
    [showFooter]="false"
    [isDarkMode]="false"
    (pdfViewerClose)="onCloseFullScreen()"
    (headerDownloadButtonClick)="onDownloadDocument()"
    >
  </mytax-pdf-viewer>
</div>
